import auth from '../../api/auth'
import cookies from '../../utilities/cookies'
import * as types from './types'

const Promise = window.Promise || require('promise')

const authCheck = (dispatch, token) => {
  return auth.check(token)
    .then(data => {
      cookies.set('bhunterToken', data.token, { expires: 86400 })
      dispatch('setToken', data.token)
      dispatch('setData', data.user)
      dispatch('tirggerAuthCheck', true)
      return Promise.resolve()
    }, () => {
      cookies.set('bhunterToken', '', { expires: -1 })
      dispatch('setToken', '')
      dispatch('setData', {})
      dispatch('tirggerAuthCheck', false)
      return Promise.reject()
    })
}

export const setToken = ({ commit }, token) => {
  commit(types.TOKEN, token)
}

export const setData = ({ commit }, data) => {
  commit(types.DATA, data)
}

export const checkAuth = ({ commit, dispatch, state }) => {
  let token
  if (state.token !== '' &&
     typeof state.token !== 'undefined'
  ) {
    token = [state.token]
  } else {
    let query
    try {
      query = window.location.search.substring(1)
      query = JSON.parse('{"' + decodeURIComponent(query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
    } catch (e) {}
    if (typeof query !== 'undefined') {
      if (typeof query.token !== 'undefined') {
        token = query.token.match(/^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*/gim)
      }
    }
  }

  if (token !== null && Array.isArray(token)) {
    if (typeof token[0] !== 'undefined') {
      return authCheck(dispatch, token[0])
    } else {
      dispatch('tirggerAuthCheck', false)
      return Promise.reject()
    }
  } else {
    token = cookies.get('bhunterToken')
    if (typeof token !== 'undefined') {
      return authCheck(dispatch, token)
    } else {
      dispatch('tirggerAuthCheck', false)
      return Promise.reject()
    }
  }
}

export const tirggerAuthCheck = ({ commit }, checked) => {
  commit(types.CHECK_AUTH, !!checked)
}

export const login = ({ commit }, loginData) => {
  return auth.login(loginData).then((data) => {
    commit(types.DATA, data.user)
    commit(types.TOKEN, data.token)
    cookies.set('bhunterToken', data.token, { expires: 86400 })
    return Promise.resolve(data)
  }, (err) => {
    commit(types.DATA, {})
    commit(types.TOKEN, '')
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/vuex/users/actions.js